import React from 'react';
import { useNavigate } from 'react-router-dom';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@400;500;600&display=swap');

.pc-card {
  background:#fff;border-radius:16px;
  border:1px solid rgba(0,0,0,.07);
  box-shadow:0 2px 12px rgba(0,0,0,.05);
  display:flex;flex-direction:column;overflow:hidden;
  transition:transform .25s ease,box-shadow .25s ease;
  cursor:pointer;position:relative;
}
.pc-card:hover { transform:translateY(-6px);box-shadow:0 18px 44px rgba(0,0,0,.12); }
.pc-card::before {
  content:'';position:absolute;top:0;left:0;right:0;height:4px;
  background:var(--accent,linear-gradient(90deg,#21808d,#134d5e));
  border-radius:16px 16px 0 0;
}
.pc-body { padding:1.6rem 1.6rem 0;flex:1; }
.pc-header { display:flex;align-items:flex-start;justify-content:space-between;gap:.75rem;margin-bottom:.9rem; }
.pc-name {
  font-family:'Playfair Display',Georgia,serif;
  font-size:1.1rem;font-weight:700;color:#0b3d4a;line-height:1.3;margin:0;flex:1;
}
.pc-status {
  display:inline-flex;align-items:center;gap:5px;
  padding:4px 10px;border-radius:999px;font-family:'DM Sans',sans-serif;
  font-size:.68rem;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
  flex-shrink:0;margin-top:2px;
}
.pc-status.ongoing  { background:rgba(33,128,141,.1);color:#21808d;border:1px solid rgba(33,128,141,.25); }
.pc-status.completed{ background:rgba(39,174,96,.1); color:#27ae60;border:1px solid rgba(39,174,96,.25);  }
.pc-sdot { width:6px;height:6px;border-radius:50%;background:currentColor;flex-shrink:0; }
.pc-desc {
  font-family:'DM Sans',sans-serif;font-size:.88rem;color:#666;line-height:1.65;margin:0;
  display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;
}
.pc-footer {
  display:flex;align-items:center;justify-content:space-between;
  padding:1rem 1.6rem 1.4rem;margin-top:1.1rem;
  border-top:1px solid rgba(0,0,0,.06);
}
.pc-year { font-family:'DM Sans',sans-serif;font-size:.8rem;color:#aaa;font-weight:500;display:inline-flex;align-items:center;gap:4px; }
.pc-btn {
  display:inline-flex;align-items:center;gap:.4rem;
  padding:.5rem 1.1rem;
  background:linear-gradient(135deg,#0b3d4a,#21808d);
  color:#fff;border:none;border-radius:8px;
  font-family:'DM Sans',sans-serif;font-size:.82rem;font-weight:600;
  cursor:pointer;transition:transform .2s,box-shadow .2s;
  box-shadow:0 3px 10px rgba(33,128,141,.25);
}
.pc-btn:hover { transform:translateY(-1px);box-shadow:0 6px 18px rgba(33,128,141,.35); }
.pc-arr { transition:transform .2s;display:inline-block; }
.pc-btn:hover .pc-arr { transform:translateX(3px); }
`;

// Inject CSS once into <head>
if (typeof document !== 'undefined' && !document.getElementById('pc-styles')) {
  const s = document.createElement('style');
  s.id = 'pc-styles';
  s.textContent = CSS;
  document.head.appendChild(s);
}

export default function ProjectCard({ project }) {
  const navigate = useNavigate();

  const accent = project.status === 'ongoing'
    ? 'linear-gradient(90deg,#21808d,#134d5e)'
    : 'linear-gradient(90deg,#27ae60,#1a7a45)';

  const go = (e) => { e.stopPropagation(); navigate(`/project/${project.id}`); };

  return (
    <div className="pc-card" style={{ '--accent': accent }} onClick={go}>
      <div className="pc-body">
        <div className="pc-header">
          <h3 className="pc-name">{project.projectName}</h3>
          <span className={`pc-status ${project.status}`}>
            <span className="pc-sdot"/>
            {project.status.charAt(0).toUpperCase() + project.status.slice(1)}
          </span>
        </div>
        <p className="pc-desc">{project.description}</p>
      </div>
      <div className="pc-footer">
        <span className="pc-year">📅 {project.year}</span>
        <button className="pc-btn" onClick={go}>
          View Gallery <span className="pc-arr">→</span>
        </button>
      </div>
    </div>
  );
}